<template>
    <div style="height: 91vh; width: 100%; display: flex; flex-direction: column; padding: 8px">
        <KepcoHeader
            :title="getHeaderName"
            :selected-period="selectedPeriod"
            :current-date-display="currentDateDisplay"
            :current-year-display="currentYearDisplay"
            :current-year="currentYear"
            :current-month="currentMonth"
            :customer-list="customerList"
            :selected-cust-no="selectedCustNo"
            :is-navigation-disabled="isNavigationDisabled"
            :months="months"
            :year-range="yearRange"
            :summary-info="detailSummaryInfo"
            :data-status="dataStatus"
            :status-message="statusMessage"
            :is-loading="isLoading"
            @update:selected-period="handlePeriodChange"
            @navigate-date="handleNavigateDate"
            @change-year="handleChangeYear"
            @select-month="handleSelectMonth"
            @select-year="handleSelectYear"
            @select-customer="handleCustomerSelect"
            @export-pdf="handleExportPdf"
            @update:selectedPeriod="handlePeriodChange"
            @go-to-dashboard="handleGoToDashboard"
        />
        <div style="flex: 1; min-height: 0">
            <dashboard-main
                v-if="!selectedCustNo"
                ref="dashboardComponent"
                :selected-period="selectedPeriod"
                :current-year="currentYear"
                :current-month="currentMonth"
                :data-status="dataStatus"
                @update-customer-list="handleUpdateCustomerList"
                @update-data-status="handleUpdateDataStatus"
                @update-status-message="handleUpdateStatusMessage"
                @update-loading-state="handleUpdateLoadingState"
                @select-customer="handleCustomerSelect"
            />
            <bill-main
                v-else
                ref="detailComponent"
                :cust-no="selectedCustNo"
                :selected-period="selectedPeriod"
                :current-year="currentYear"
                :current-month="currentMonth"
                :data-status="dataStatus"
                @update-summary="handleUpdateSummary"
                @update-data-status="handleUpdateDataStatus"
                @update-status-message="handleUpdateStatusMessage"
            />
        </div>
    </div>
</template>

<script>
import BillMain from "./components/bill/BillMain.vue";
import DashboardMain from "./components/dashboard/DashboardMain.vue";
import KepcoHeader from "./components/common/KepcoHeader.vue";

export default {
    components: {
        BillMain,
        DashboardMain,
        KepcoHeader,
    },

    data() {
        return {
            selectedCustNo: null,
            selectedPeriod: "monthly",
            currentYear: new Date().getFullYear(),
            currentMonth: new Date().getMonth(),
            customerList: [],
            detailSummaryInfo: null, // 디테일 페이지 요약 정보
            dataStatus: "", // 대시보드 데이터 상태
            statusMessage: "", // 상태 메시지
            isLoading: false, // 로딩 상태
            months: [
                { value: 1, name: "1월" },
                { value: 2, name: "2월" },
                { value: 3, name: "3월" },
                { value: 4, name: "4월" },
                { value: 5, name: "5월" },
                { value: 6, name: "6월" },
                { value: 7, name: "7월" },
                { value: 8, name: "8월" },
                { value: 9, name: "9월" },
                { value: 10, name: "10월" },
                { value: 11, name: "11월" },
                { value: 12, name: "12월" },
            ],
        };
    },
    computed: {
        currentDateDisplay() {
            return `${this.currentYear}년 ${this.currentMonth + 1}월`;
        },
        currentYearDisplay() {
            return `${this.currentYear}년`;
        },
        yearRange() {
            const currentYear = new Date().getFullYear();
            const years = [];
            for (let i = currentYear - 5; i <= currentYear + 5; i++) {
                years.push(i);
            }
            return years;
        },
        isNavigationDisabled() {
            return false;
        },
        getHeaderName() {
            if (!this.selectedCustNo) {
                return {
                    custNm: "전기 청구 내역 분석",
                    custNo: "-",
                    type: "dashboard",
                };
            }
            return {
                custNm: this.customerList.find((customer) => customer.custNo === this.selectedCustNo)?.custNm,
                custNo: this.selectedCustNo,
                type: "bill",
            };
        },
    },
    methods: {
        handleCustomerSelect(custNo) {
            this.selectedCustNo = custNo;
            // 고객 상세로 이동 시에는 BillMain에서 emit되는 상태를 기다림
            // 초기 상태를 active로 설정하되, API 응답 후 실제 상태로 업데이트됨
            if (custNo) {
                this.dataStatus = "active";
            }
        },
        handlePeriodChange(period) {
            this.selectedPeriod = period;
        },
        handleNavigateDate(direction) {
            if (this.selectedPeriod === "monthly") {
                this.currentMonth += direction;
                if (this.currentMonth > 11) {
                    this.currentMonth = 0;
                    this.currentYear += 1;
                } else if (this.currentMonth < 0) {
                    this.currentMonth = 11;
                    this.currentYear -= 1;
                }
            } else {
                this.currentYear += direction;
            }
        },
        handleChangeYear(direction) {
            this.currentYear += direction;
        },
        handleSelectMonth(month) {
            this.currentMonth = month - 1;
        },
        handleSelectYear(year) {
            this.currentYear = year;
        },
        handleUpdateCustomerList(list) {
            this.customerList = list;
        },
        handleExportPdf() {
            // 대시보드일 때는 dashboardComponent, 고지서일 때는 detailComponent의 exportPDF 호출
            if (this.selectedCustNo) {
                this.$refs.detailComponent?.exportPDF?.();
            } else {
                this.$refs.dashboardComponent?.exportPDF?.();
            }
        },
        handleUpdateSummary(summaryInfo) {
            this.detailSummaryInfo = summaryInfo;
        },
        handleGoToDashboard() {
            this.selectedCustNo = null;
        },
        handleUpdateDataStatus(status) {
            this.dataStatus = status;
        },
        handleUpdateStatusMessage(message) {
            this.statusMessage = message;
        },
        handleUpdateLoadingState(loading) {
            this.isLoading = loading;
        },
    },
};
</script>
